import { useEffect, useState } from 'react';
import { loadReportProjectWorkItemsForDisplay } from '@/services/report-daily-fusion';
import type { ProjectWorkItemFormValue } from '@/types/report-project-work-item-lite';
import type { ReportRecord } from '@/types/report';

export function useReportProjectWorkItemsDisplay(report: ReportRecord | null) {
  const [items, setItems] = useState<ProjectWorkItemFormValue[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!report) {
      setItems([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    void loadReportProjectWorkItemsForDisplay(report.user.id, report.id, report.reportDate)
      .then((result) => {
        if (!cancelled) {
          setItems(result);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [report?.id, report?.reportDate, report?.user.id]);

  return { items, loading };
}
